import React, { useEffect, useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import rectangle_background from "../../assets/images/login_dashboard_container.jpg";
import { animated, Transition } from "react-spring/renderprops";
import shapes_accountPage from "../../assets/images/shapes_and_images_accountPage.png";
import qs from "qs";
import * as yup from "yup";
import logo from "../../assets/images/logo-tilted-small.png";
import { usePhoneViewport } from "../../hooks/usePhoneViewport";
import "../../pages/Login/Register/register-connect-mobile.scss";

// @ts-ignore
import StarRatings from "react-star-ratings";

type DecorMedia = {
  face1: string;
  face2: string;
  face3: string;
  email1: string;
  email2: string;
  email3: string;
};

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://emailwish.com/">
        Emailwish
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  "@keyframes pulsate": {
    "0%": {
      transform: "scale(1)",
      boxShadow: "0 0 0 0 rgba(0, 230, 118, 0.4)",
    },
    "70%": {
      transform: "scale(1.2)",
      boxShadow: "0 0 0 10px rgba(0, 230, 118, 0)",
    },
    "100%": {
      transform: "scale(1)",
      boxShadow: "0 0 0 0 rgba(0, 230, 118, 0)",
    },
  },
  root: {
    height: "100vh",
    [theme.breakpoints.down('sm')]: {
      height: "auto",
      minHeight: "100vh",
    },
  },
  rootChild: {
    padding: 30,
    display: "flex",
    flexFlow: "column",
    justifyContent: "center",
    position: "relative",
    backgroundColor: "#f8f8f8",
    overflow: "hidden",
    [theme.breakpoints.up('md')]: {
      paddingRight: '40px',
    },
    [theme.breakpoints.down('sm')]: {
      width: "100%",
      padding: "max(20px, env(safe-area-inset-top, 0px)) 18px 16px",
      backgroundColor: "#fff",
      justifyContent: "flex-start",
      overflowX: "clip",
      overflowY: "visible",
      minHeight: "100vh",
      boxSizing: "border-box",
    },
  },
  rootImage: {
    padding: 0,
    backgroundColor: "#F8FAFF",
    height: "100%",
    position: "relative",
    display: "flex",
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      display: "none",
    },
  },
  h1: {
    fontSize: 30,
    fontFamily: "Syne",
    fontWeight: 500,
    letterSpacing: '-0.03em',
    fontKerning: 'none',
  },
  h1Black: {
    fontSize: 30,
    fontFamily: "Syne",
    fontWeight: 500,
    letterSpacing: '-0.03em',
    marginTop: 20,
    fontKerning: 'none',
    backgroundColor: "black",
    color: "white",
  },
  loginFormLogo: {
    display: "flex",
    justifyContent: "center",
    marginBottom: theme.spacing(5),
    "& img": {
      width: "150px",
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(3),
      paddingTop: theme.spacing(1),
    },
  },
  copyrightContainer: {
    marginTop: theme.spacing(5),
    zIndex: 5,
  },
  registerCardSideBarItem: {
    height: "100%",
    width: "100%",
    position: "relative",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },

  // Geometric shapes for decoration
  shapeCircle: {
    position: "absolute",
    borderRadius: "50%",
    backgroundColor: "#6500ff", // Main brand color
    opacity: 0.1,
  },
  shapeStar: {
    position: "absolute",
    color: "#a794ed", // Secondary brand color
    fontSize: "40px",
    fontWeight: "bold",
    transform: "rotate(15deg)",
  },
  shapePill: {
    position: "absolute",
    borderRadius: "20px",
    backgroundColor: "#a794ed",
    opacity: 0.2,
  },
  shapeSolid: {
    position: "absolute",
    opacity: 1,
    zIndex: 1,
  },
  gridPattern: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundImage: `radial-gradient(#a794ed 1px, transparent 1px)`,
    backgroundSize: "30px 30px",
    opacity: 0.15,
    zIndex: 0,
  },
  blackCircleArrow: {
    position: "absolute",
    top: "40px",
    right: "40px",
    width: "56px",
    height: "56px",
    backgroundColor: "#0f172a",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
    zIndex: 30,
  },
  floatingCard: {
    position: "absolute",
    backgroundColor: "white",
    borderRadius: "16px",
    padding: "16px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
    zIndex: 25,
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  emailCard: {
    position: "absolute",
    zIndex: 5,
    "& img": {
      width: "100%",
    }
  },
  automationLabel: {
    position: "absolute",
    fontSize: "11px",
    fontWeight: 800,
    color: "#0f172a",
    letterSpacing: "0.05em",
    zIndex: 25,
    textTransform: "uppercase",
  },
  miniFloatingBadge: {
    position: "absolute",
    backgroundColor: "white",
    borderRadius: "14px",
    padding: "12px 20px",
    boxShadow: "0 15px 35px rgba(0,0,0,0.2)",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    zIndex: 25,
    fontSize: "14px",
    fontWeight: "bold",
    color: "#0f172a",
  },
  statusDot: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    backgroundColor: "#00E676",
    animation: "$pulsate 2s infinite",
  },

  registerCardSideBarItemTypoDesc: {
    fontSize: "36px",
    color: "#0f172a",
    marginTop: theme.spacing(3),
    fontWeight: 700,
    textAlign: "center",
    width: "100%",
    lineHeight: 1.2,
    fontFamily: "Syne",
  },
  registerCardSideBarItemTypoName: {
    fontSize: "18px",
    color: "#475569",
    paddingTop: theme.spacing(2),
    textAlign: "center",
    maxWidth: 400,
    margin: "0 auto",
  },

  avatarGroup: {
    display: "flex",
    justifyContent: "center",
    marginTop: "40px",
  },
  avatarItem: {
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    border: "4px solid white",
    objectFit: "cover",
    marginLeft: "-20px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  },
  avatarItemFirst: {
    marginLeft: "0",
  },
  highlightBox: {
    backgroundColor: "#6500ff",
    color: "white",
    padding: "4px 12px",
    borderRadius: "8px",
    display: "inline-block",
    transform: "rotate(-2deg)",
  },
  testimonialMiniCard: {
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    backdropFilter: "blur(10px)",
    borderRadius: "16px",
    padding: "16px 20px",
    marginTop: "40px",
    maxWidth: "350px",
    boxShadow: "0 8px 32px rgba(0,0,0,0.05)",
    textAlign: "left",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    border: "1px solid rgba(255,255,255,0.5)",
    position: "relative",
    zIndex: 20
  },
  testimonialMiniText: {
    fontSize: "14px",
    color: "#475569",
    fontStyle: "italic",
    lineHeight: 1.4,
  },
  testimonialMiniAuthor: {
    fontSize: "13px",
    color: "#0f172a",
    fontWeight: "bold",
  },
  registerCardSideBar: {
    flex: 1,
    height: "100%",
    width: "100%",
    display: "flex",
  },
  image: {
    rounded: 50,
    height: "100%",
    width: "100%",
    backgroundImage:
      "url(https://builder.emailwish.com/assets/templates/66266b2b4f180/thumbnail.png)",
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: "cover",
    backgroundPosition: "center",
    justifyContent: "end",
    display: "flex",
    alignItems: "end",
  },
  paperHead: {
    display: "flex",
    justifyContent: "center",
    height: "auto",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.down('sm')]: {
      width: "100%",
      maxWidth: "100%",
      alignItems: "stretch",
      boxSizing: "border-box",
    },
  },
  paper: {
    background: "#ffffff",
    padding: 60,
    maxWidth: 620,
    borderRadius: 12,
    display: "flex",
    rowGap: 60,
    flexDirection: "column",
    alignItems: "start",
    boxShadow: "0 20px 60px rgba(0,0,0,0.08)",
    zIndex: 10,
    [theme.breakpoints.down('md')]: {
      padding: "40px 25px",
      minWidth: "unset",
      rowGap: 30,
    },
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  rememberMe: {
    margin: theme.spacing(3, 0, 2),
  },
  submit: {
    marginTop: theme.spacing(10),
    padding: 12,
    fontFamily: "Syne",
    fontSize: 16,
    boxShadow: "none",
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function DashboardLayer({ children }: { children: any | Element | null }) {
  const classes = useStyles();
  const isPhoneView = usePhoneViewport();
  const [decor, setDecor] = useState<DecorMedia | null>(null);

  useEffect(() => {
    let cancelled = false;
    const idle = window.setTimeout(() => {
      void Promise.all([
        import("../../assets/images/faces/For Chats/studio-portrait-emotional-happy-funny-smiling-boyfriend-man-with-heavy-beard-stands-with-arms-crossed-dressed-red-t-shirt-isolated-blue.jpg"),
        import("../../assets/images/faces/face2.jpg"),
        import("../../assets/images/faces/face3.jpg"),
        import("../../assets/images/emails/email1.png"),
        import("../../assets/images/emails/email2.png"),
        import("../../assets/images/emails/email3.png"),
      ]).then(([f1, f2, f3, e1, e2, e3]) => {
        if (!cancelled) {
          setDecor({
            face1: f1.default,
            face2: f2.default,
            face3: f3.default,
            email1: e1.default,
            email2: e2.default,
            email3: e3.default,
          });
        }
      });
    }, 0);
    return () => {
      cancelled = true;
      window.clearTimeout(idle);
    };
  }, []);
  const mobileLayerClass = isPhoneView ? "register-layer-mobile" : "";

  useEffect(() => {
    if (!isPhoneView) {
      return;
    }
    document.body.classList.add("register-mobile-layout");
    return () => document.body.classList.remove("register-mobile-layout");
  }, [isPhoneView]);

  return (
    <Grid container component="main" className={`${classes.root} ${mobileLayerClass}`} style={{ width: '100vw', maxWidth: '100vw', margin: 0, overflowX: isPhoneView ? 'clip' : 'hidden' }}>
      <CssBaseline />
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        className={`${classes.rootChild} register-layer-mobile__content`}
      >
        {/* Background Decor for Left Side */}
        <div className={`${classes.shapeCircle} register-layer-mobile__decor`} style={{ width: 300, height: 300, top: -150, left: -150, backgroundColor: "#a794ed", opacity: 0.05 }} />
        <div className={`${classes.shapeStar} register-layer-mobile__decor`} style={{ bottom: "20%", left: "10%", color: "#FFB020", opacity: 0.15 }}>✦</div>
        <div className={`${classes.shapePill} register-layer-mobile__decor`} style={{ width: 100, height: 40, bottom: "15%", left: "20%", backgroundColor: "#FF2B7A", transform: "rotate(45deg)", opacity: 0.05 }} />

        <div className={classes.paperHead} style={{ zIndex: 10 }}>
          <Box style={{ zIndex: 5 }}>
            <div className={`${classes.loginFormLogo} register-layer-mobile__logo`}>
              <div>
                <img src={logo} alt="Emailwish logo" />
              </div>
            </div>
          </Box>
          <div className={`${classes.paper} register-layer-mobile__paper`}>
            {children ?? null}
          </div>
          <Box className={`${classes.copyrightContainer} register-layer-mobile__copyright`}>
            <Copyright />
          </Box>
        </div>
      </Grid>
      <Grid item xs={false} sm={false} md={6} className={classes.rootImage}>
        {/* <div className={classes.image} >
        </div>       */}
        <div className={classes.registerCardSideBar}>
          <Grid
            container
            className={classes.registerCardSideBarItem}
            alignItems="center"
            justifyContent="center"
            style={{ width: '100%', height: '100%' }}
          >

            {/* Background Decor */}
            <div className={classes.gridPattern} />

            <div className={classes.shapeCircle} style={{ width: 500, height: 500, top: -200, right: -200, backgroundColor: "#6500ff", opacity: 0.12 }} />
            <div className={classes.shapeCircle} style={{ width: 300, height: 300, bottom: -100, left: -100, backgroundColor: "#FFB020", opacity: 0.15 }} />

            <div className={classes.shapeSolid} style={{ width: 80, height: 80, top: "15%", left: "10%", backgroundColor: "#a794ed", borderRadius: "50%", opacity: 0.25 }} />
            <div className={classes.shapeSolid} style={{ width: 40, height: 40, bottom: "10%", right: "20%", backgroundColor: "#00E676", borderRadius: "50%", opacity: 0.35 }} />

            <div className={classes.shapePill} style={{ width: 160, height: 60, top: 90, left: 210, transform: "rotate(-15deg)", backgroundColor: "#FF2B7A", opacity: 0.25 }} />
            <div className={classes.shapePill} style={{ width: 120, height: 45, bottom: 180, right: 100, backgroundColor: "#6500ff", transform: "rotate(35deg)", opacity: 0.25 }} />

            <div className={classes.shapeStar} style={{ top: 100, right: 180, color: "#6500ff" }}>✦</div>
            <div className={classes.shapeStar} style={{ top: "15%", left: "35%", color: "#FFB020", fontSize: "48px", opacity: 0.2 }}>✦</div>
            <div className={classes.shapeStar} style={{ bottom: 150, left: 140, color: "#FFB020", fontSize: "42px" }}>✦</div>
            <div className={classes.shapeStar} style={{ top: 250, right: 100, color: "#FF2B7A", fontSize: "28px" }}>✦</div>

            <div className={classes.shapePill} style={{ width: 80, height: 30, top: "20%", left: "45%", backgroundColor: "#a794ed", transform: "rotate(20deg)", opacity: 0.15 }} />



            {/* Floating Email Cards - Positioned further out to avoid overlapping */}
            {decor && (
              <>
            <div className={classes.emailCard} style={{ top: "5%", left: "3%", width: "220px", transform: "rotate(-8deg)" }}>
              <img src={decor.email1} alt="" loading="lazy" decoding="async" />
            </div>

            <div className={classes.emailCard} style={{ top: "12%", right: "3%", width: "240px", transform: "rotate(10deg)" }}>
              <img src={decor.email2} alt="" loading="lazy" decoding="async" />
            </div>

            <div className={classes.emailCard} style={{ bottom: "5%", left: "3%", width: "230px", transform: "rotate(6deg)" }}>
              <img src={decor.email3} alt="" loading="lazy" decoding="async" />
            </div>
              </>
            )}

            {/* Automation Badges with Specific Names - Enhanced styling and positions */}
            <div className={classes.miniFloatingBadge} style={{ top: "16%", left: "12%", transform: "rotate(-8deg)" }}>
              <div className={classes.statusDot} />
              Abandoned Carts
            </div>

            <div className={classes.miniFloatingBadge} style={{ top: "18%", right: "12%", transform: "rotate(10deg)" }}>
              <div className={classes.statusDot} />
              Popup Flows
            </div>

            <div className={classes.miniFloatingBadge} style={{ bottom: "10%", left: "14%", transform: "rotate(6deg)" }}>
              <div className={classes.statusDot} />
              Review Request
            </div>



            <Transition
              items={1}
              from={{ opacity: 0, transform: "translate3d(0px,40px,0)" }}
              enter={{ opacity: 1, transform: "translate3d(0px,0px,0)" }}
              leave={{ opacity: 0, transform: "translate3d(0px,0px,0)" }}
              config={{ duration: 1400 }}
            >
              {(page) => (props) => (
                <animated.div style={{ ...props, zIndex: 10, textAlign: "center", width: '100%', padding: '0 40px' }}>

                  <div className={classes.registerCardSideBarItemTypoDesc}>
                    All your <span className={classes.highlightBox}>customer journeys</span>,<br />
                    already built
                  </div>

                  <div className={classes.registerCardSideBarItemTypoName} style={{ color: "#475569", fontSize: "16px", fontWeight: 500, margin: "24px auto 0", padding: 0, maxWidth: "350px", textAlign: "center" }}>
                    Automate emails, popups, chats, and reviews, from abandoned carts to winbacks, without complex setup.
                  </div>

                  {/* Overlapping Fun Avatars */}
                  <div className={classes.avatarGroup}>
                    {decor ? (
                      <>
                    <img src={decor.face1} alt="" className={`${classes.avatarItem} ${classes.avatarItemFirst}`} style={{ borderColor: "#00E676" }} loading="lazy" decoding="async" />
                    <img src={decor.face2} alt="" className={classes.avatarItem} style={{ borderColor: "#FFB020" }} loading="lazy" decoding="async" />
                    <img src={decor.face3} alt="" className={classes.avatarItem} style={{ borderColor: "#FF2B7A" }} loading="lazy" decoding="async" />
                      </>
                    ) : null}
                    <div className={classes.avatarItem} style={{
                      backgroundColor: "#6500ff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontWeight: "bold",
                      fontSize: "20px"
                    }}>
                      +2k
                    </div>
                  </div>

                  {/* Mini Testimonial - Now centered in the layout */}
                  <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginTop: '30px' }}>
                    <div className={classes.testimonialMiniCard} style={{ marginTop: 0 }}>
                      <StarRatings
                        rating={5}
                        starRatedColor={"#FFB020"}
                        starEmptyColor={"#eee"}
                        numberOfStars={5}
                        name="rating"
                        starDimension={"14px"}
                        starSpacing="2px"
                      />
                      <div className={classes.testimonialMiniText}>
                        "An incredibly useful app. Easy to set up automations, and support is genuinely fast and helpful. Highly recommended!"
                      </div>
                      <div className={classes.testimonialMiniAuthor}>
                        — Camilla B, Founder of Blululi
                      </div>
                    </div>
                  </div>

                </animated.div>
              )}
            </Transition>
          </Grid>
        </div>
      </Grid>
    </Grid>
  );
}
